import { BCMSCurrency, useBCMSModal } from "@bcm-dev/bcms-vite";
import { FormContainer, FormRow, FormRowView } from "components/shared";
import { UICheckbox } from "components/ui";
import React, { useEffect } from "react";
import { SVGAsset } from "res";
import ACHTransfersToTable from "../../../../shared/widgets/ACHWidgets/ACHTransfersToTable";
import MobileACHTransfersToTable from "../../../../shared/widgets/ACHWidgets/MobileACHTransfersToTable";
import "./styles.css";

/**
 * @function TemplateDetailsToSection
 * @return {React.Component}
 * @exported true
 * @description The section that shows the To information in the TemplateDetailsPage
 */

export default function TemplateDetailsToSection(props) {
  const ui = props.ui ?? {};
  const data = props.data ?? {};
  const action = props.action ?? {};
  const { open } = useBCMSModal();
  const participants = data.participants ?? [];
  const achToParticipants = data.achToParticipants ?? [];
  const onParticipantRowChange = action.onParticipantRowChange ?? (() => {});
  const onParticipantModalCancelClick = action.onParticipantModalCancelClick ?? (() => {});
  const onParticipantsModalAddSelectedParticipantsClick  = action.onParticipantsModalAddSelectedParticipantsClick ?? (() => {});
  const onACHToParticipantChange = action.onACHToParticipantChange ?? (() => {});
  const onACHToParticipantDelete = action.onACHToParticipantDelete ?? (() => {});
  const onSelectAllParticipantsCheckboxChange = action.onSelectAllParticipantsCheckboxChange ?? (() => {});
  const achParticipantsModalIsOpen = ui.achParticipantsModalIsOpen.isActive ?? false;
  const onAddParticipantsOpenModalClick = action.onAddParticipantsOpenModalClick ?? (() => {});
  const showHoldPrenoteDistributionColumns = props.showHoldPrenoteDistributionColumns ?? false;

  const inAchToParicipants =(id)=>{
      return  achToParticipants.participants.filter((toParticipant)=>{
              return toParticipant.participant?  toParticipant.participant.id == id: false;
          }).length !== 0;
      }
      const unUsedParticipants = participants.filter((participant)=>{
          return !inAchToParicipants(participant.id)
      })
    
 
  let modalData = {
    modalTitle: "ACH Participants",
    participants: unUsedParticipants, onParticipantRowChange,
    onParticipantModalCancelClick, onParticipantsModalAddSelectedParticipantsClick, 
    onSelectAllParticipantsCheckboxChange,
    groupSearchValue: data.groupSearchValue
  };

  let amount = achToParticipants.participants.reduce((acc, item) => {
      const currAmount = item.amount.amount;
      if(currAmount) {
        if(!item.hold) return acc + parseFloat(currAmount);
        
      }
      return acc;
  }, 0);
  amount = BCMSCurrency.init(amount);

  let hold = achToParticipants.participants.reduce((acc, item) => {
      const currAmount = item.amount.amount;
      if(currAmount) {
        if(item.hold) return acc + parseFloat(currAmount);
      }
      return acc;
  }, 0);
  hold = BCMSCurrency.init(hold);

  let prenote = achToParticipants.participants.reduce((acc, item) => {
    const currAmount = item.amount.amount;
    if(item.prenote && currAmount > 0) return acc + 1;
    return acc;
}, 0);

  // HACK: Pass data to modal through use effect since renders do not propagate to modals.
  useEffect(() => {
      if(achParticipantsModalIsOpen) open("ACHParticipantsModal", modalData);
  }, [ participants ]);

  // On click, we will set "achParticipantsModalIsOpen" to true which will tell us that the modal is open.
  // We will pass data to the modal through the "open" hook.
  const onAddParticipantsClick = evt => {
      onAddParticipantsOpenModalClick();
      open("ACHParticipantsModal", modalData);
  };
  
  return (
    <div className="one-time-ach-payment-section template-details-to-section">
      <h2 className="section-title">ACH To</h2>
      <FormContainer className="template-details-to-section-form">
        <FormRowView>
          <UICheckbox label="Use Participant Distributions" value="" />
        </FormRowView>
      </FormContainer>
      <div className="show-on-desktop">
        <ACHTransfersToTable achToParticipants={ achToParticipants } onACHToParticipantChange={ onACHToParticipantChange } 
        onACHToParticipantDelete={ onACHToParticipantDelete } showHoldPrenoteDistributionColumns={ showHoldPrenoteDistributionColumns } />
      </div>
      <div className="show-on-mobile">
        <MobileACHTransfersToTable achToParticipants={ achToParticipants } onACHToParticipantChange={ onACHToParticipantChange }
         onACHToParticipantDelete={ onACHToParticipantDelete } showHoldPrenoteDistributionColumns={ showHoldPrenoteDistributionColumns } />
      </div>
      <FormContainer>
        <FormRow>
          <div className="flex-container flex-horizontal align-center set-width">
            <p className="form-detail-row flex-container align-center">
              <span className="form-detail form-detail-label">Credit Amount</span>
              <span className="form-detail form-detail-text"> { amount.format() }</span>
              <SVGAsset id="QuestionMarkCircleIcon" className="question-mark-circle-icon" />
            </p>
            <p className="form-detail-row flex-container align-center">
              <span className="form-detail form-detail-label">Hold Total</span>
              <span className="form-detail form-detail-text">{ hold.format() }</span>
              <SVGAsset id="QuestionMarkCircleIcon" className="question-mark-circle-icon" />
            </p>
            <p className="form-detail-row flex-container align-center">
              <span className="form-detail form-detail-label">Prenotes</span>
              <span className="form-detail form-detail-text">{ prenote }</span>
            </p>
          </div>
        </FormRow>
        <FormRow>
          <a onClick={ onAddParticipantsClick } >
            <span data-point="Add_Participants_Link">Add Participants</span> 
          </a>
        </FormRow>
      </FormContainer>
    </div>
  )
}